import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import CustomTable from "../../../components/CustomTable/CustomTable";
import PaginationHandler from "../../../components/PaginationHandler";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { usePagination } from "../../../hooks/usePagination";
import { useTranslation } from "react-i18next";
import { deleteRole, getRoles } from "../../../api/roles";
import React, { useEffect } from "react";

export default function RolesTable() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const role = currentUser.role || currentUser.roleName || {};
  const isSuperAdmin = role.name === "super admin";

  const { response, loading, error, setPage, page, setMeta, totalPages } =
    usePagination(getRoles, null, true);

  const handleDelete = async (roleId) => {
    if (window.confirm("Are you sure you want to delete this role?")) {
      try {
        await deleteRole(roleId);
        setPage(1);
      } catch (err) {
        console.error("Failed to delete role:", err);
        alert("Failed to delete role. Please try again.");
      }
    }
  };

  useEffect(() => {
    console.log("Current User Role:", role.name);
  }, [role]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={"Roles"}
          addUrl={isSuperAdmin ? "/add-role" : null}
          hasAddBtn={isSuperAdmin}
          isMainPage={true}
        />

        {/* Only super admin can view the Roles Table */}
        {isSuperAdmin ? (
          response && response.length > 0 && !loading ? (
            <CustomTable
              emptyMsg={"No Roles Found."}
              data={response}
              loading={loading}
              error={error}
              cols={[
                {
                  label: "Role Name",
                  key: "name",
                  style: { width: "20%" },
                  renderer: (row) => row.name || "N/A",
                },
                {
                  label: "Permissions",
                  key: "permissions",
                  style: { width: "50%" },
                  renderer: (row) => {
                    if (!row.permissions || row.permissions.length === 0)
                      return "Has No access";
                    const resourceMap = {};
                    row.permissions.forEach((perm) => {
                      const { resource, actions } = perm;
                      if (!resourceMap[resource]) {
                        resourceMap[resource] = new Set();
                      }
                      actions.forEach((action) =>
                        resourceMap[resource].add(action)
                      );
                    });

                    const requiredActions = [
                      "create",
                      "read",
                      "update",
                      "delete",
                    ];

                    return (
                      <>
                        {Object.entries(resourceMap).map(
                          ([resource, actionsSet], index) => {
                            const hasFullAccess = requiredActions.every((act) =>
                              actionsSet.has(act)
                            );

                            return (
                              <div key={index} className="mb-2">
                                {hasFullAccess ? (
                                  <p>
                                    Full access for{" "}
                                    {resource.charAt(0).toUpperCase() +
                                      resource.slice(1)}
                                  </p>
                                ) : (
                                  [...actionsSet].map((action, i) => (
                                    <div key={i}>
                                      {action}{" "}
                                      {resource.charAt(0).toUpperCase() +
                                        resource.slice(1)}
                                    </div>
                                  ))
                                )}
                              </div>
                            );
                          }
                        )}
                      </>
                    );
                  },
                },
                {
                  label: "Actions",
                  key: "actions",
                  style: { width: "30%" },
                  renderer: (row) => (
                    <div className="d-flex gap-2">
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => navigate(`/roles/edit/${row._id}`)}
                      >
                        Edit
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleDelete(row._id)}
                      >
                        Delete
                      </Button>
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            !loading && <div>No results found.</div>
          )
        ) : (
          <div>You do not have permission to view this list.</div>
        )}

        {/* Pagination */}
        {response && !loading && isSuperAdmin && (
          <PaginationHandler
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        )}
      </div>
    </div>
  );
}
